import BlogEditor from '@/components/blog/BlogEditor';
import { Button } from '@/components/ui/button';
import { useBlogQueries } from '@/hooks/queries/useBlogQueries';
import { BlogPostForm } from '@/types/blog';
import { createFileRoute, Link, useNavigate, useParams } from '@tanstack/react-router';
import { ChevronLeft } from 'lucide-react';

export const Route = createFileRoute('/_public/blog/$slug/_admin/edit')({
  component: BlogEditPage,
})


export default function BlogEditPage() {

  const navigate = useNavigate();

  const { slug } = useParams({ from: '/_public/blog/$slug/_admin/edit' });
  const { useFetchBlogPost, updateBlogPostMutation } = useBlogQueries();
  const { data: post } = useFetchBlogPost(slug);

  const handleSubmit = async (data: BlogPostForm) => {
    await updateBlogPostMutation.mutate({ slug: slug, data }, {
      onSuccess: () => navigate({ to: `/blog/$slug`, params: { slug: slug } })
    });
  };

  return (
    <div className="min-h-screen bg-background py-12">
      <div className="mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <Button
            variant="ghost"
            className="mb-8"
            asChild
          >
            <Link to="/blog/$slug" params={{ slug: slug }}>
              <ChevronLeft className="h-4 w-4 mr-2" />
              Back to Post
            </Link>
          </Button>

          <h1 className="text-3xl font-bold mb-8">Edit Post</h1>
          <BlogEditor
            onSubmit={handleSubmit}
            isSubmitting={updateBlogPostMutation.isPending}
            defaultValues={post}
          />
        </div>
      </div>
    </div >
  );
}
